import { FetchResult, MutationFunction } from '@apollo/client';
import { parse } from 'qs';

import { EventTrack, pushEventTracking } from 'src/app/helpers/analytics';
import { getWatchlistMutationOptions } from 'src/app/helpers/graphql';
import { GA_EVENT_CATEGORY } from 'src/app/constants/analytics';
import { LoginFunction } from 'src/app/models/login';
import { UserIdOnly } from 'src/app/models/user';
import { AddWatchlistResult, Video } from 'src/app/models/video';

export function onAddToWatchlistClick(addWatchlistMutation: MutationFunction<AddWatchlistResult>, openLoginPopup: LoginFunction, showToast: FunctionStringCallback, video: Video, user?: UserIdOnly, pushEventTrack?: EventTrack): void {
  if (user) {
    showToast('toast.add.watchlist');
    addWatchlistMutation(getWatchlistMutationOptions(video, true))
      .then((result: FetchResult<AddWatchlistResult>) => {
        if (!result || !result.data || !result.data.addVideoToWatchlist.isInWatchlist) {
          showToast('toast.add.watchlist.failed');
        }
      });
    if (pushEventTrack) {
      pushEventTracking(
        GA_EVENT_CATEGORY.ADD_BUTTON,
        'add to watchlist',
        pushEventTrack['eventDetails.label'],
        pushEventTrack.custom
      );
    }
  } else {
    const eventTrack: EventTrack = {
      'eventDetails.category': GA_EVENT_CATEGORY.DEFAULT,
      'eventDetails.action': 'intent to login',
      'eventDetails.label': 'add to watchlist'
    };
    openLoginPopup('watchlist', false, eventTrack);
  }
}

export function parseListParams(search: string): string | null {
  const { list } = parse(search.replace(/\?/g, ''));
  return (list as string) || null;
}
